module.exports = __webpack_public_path__ + "static/media/hardware.eb8ded96.png";